import * as React from "react";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";

import { TITLE_TEMPLATE_BATSOFT } from "@config/consts";

import { DefaultLayout } from "@ui/Layouts";

import { useTranslate } from "@hooks/useTranslate";

import {
  LoadingIndicator as Loading,
  FooterContainer,
  Header,
} from "@soft/containers";
import { getCountry } from "@soft/redux/localisation/localisation.selectors";

interface Props {
  children: React.ReactNode;
}

const DefaultLayoutSoft = (props: Props): React.ReactElement => {
  const location = useLocation();
  const translate = useTranslate();

  const country = useSelector(getCountry);

  return (
    <DefaultLayout
      country={country}
      title={translate("batsoft_pwa_generic.meta_title")}
      titleTemplate={TITLE_TEMPLATE_BATSOFT}
      header={<Header useNativeLinks={false} pathname={location.pathname} />}
      loading={<Loading />}
      footer={<FooterContainer />}
      somethingWentWrongText={translate(
        "batsoft_pwa_generic.something_went_wrong",
      )}
      appCrashExplanationText={translate(
        "batsoft_pwa_generic.app_crash_explanation",
      )}
    >
      {props.children}
    </DefaultLayout>
  );
};

DefaultLayoutSoft.displayName = "DefaultLayoutSoft";

export { DefaultLayoutSoft };
